import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import MainPageLayout from "../../layouts/MainPageLayout";
import axios from "axios";
import { apiToken, backendUrl, baseUrl } from "../../utils/base_url";
import { MarkdownComponent } from "../../layouts/FormLayout";
import moment from "moment";
import BlogListingNav from "./BlogListingNav";
import BlogListingFooter from "./BlogListingFooter";
import MainLayout from "../../layouts/MainLayout";
import { FaBullseye } from "react-icons/fa";
import { fetchPageData } from "../../endpoint/pageApi";
import { ImStumbleupon } from "react-icons/im";
import { Breadcrumb } from "antd";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../../utils/mediaBreakpoints";
import { useMediaQuery } from "react-responsive";
import QuotationCard from "./QuotationCard";
import BlogCard, { BlogCardWithoutCol } from "../Blog/BlogCard";
import { MdEmail } from "react-icons/md";
import toast, { Toaster } from "react-hot-toast";

<style>
  {`
    .subscription-sticky {
      position: sticky;
      top: 90px; /* Adjust this value to match your navbar height */
      z-index: 1050;
    }
  `}
</style>;

export const onSubmit = async (e, setBtnLaoder) => {
  e.preventDefault(); // page reload prevent

  const formData = new FormData(e.target);
  const email = formData.get("email");

  const payload = {
    email: email,
  };
  try {
    setBtnLaoder(true);
    // for strapi form
    let res = await axios.post(
      `${backendUrl}/demo-form/api/subscribe`,
      payload
      // {
      //   headers: {
      //     Authorization: `Bearer ${apiToken}`,
      //   },
      // }
    );
    console.log("response", res);
    // toast.success("Operation successful!");
    toast.success(res?.data?.message);
    e.target.reset();
    //     toast.success(`${formData["firstName"]} ${formData["lastName"]} Your Demo Request Submitted!`);
    //     setBtnLaoder(false);
    //     setTimeout(() => {
    //       window.location.reload()
    //     }, 2500)
  } catch (e) {
    console.log(e);
    setBtnLaoder(false);
    // alert(e)
    toast.error(e?.response?.data?.detail);
  }
};

const SingleBlog = ({ isMobile }) => {
  const { slug } = useParams();
  const [blogData, setBlogData] = useState();
  const [loader, setLoader] = useState(FaBullseye);
  const [fetchBlogs, setFetchblogs] = useState([]);
  const Navigate = useNavigate();
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const [btnLoader, setBtnLaoder] = useState(false);

  useEffect(() => {
    const fetchBlogDetail = async () => {
      setLoader(true);
      try {
        const res = await axios.get(
          `${baseUrl}/api/blogs?filters[slug][$eq]=${slug}`,
          {
            headers: {
              Authorization: `Bearer ${apiToken}`,
            },
          }
        );
        setBlogData(res?.data?.data[0]);

        setLoader(false);
      } catch (err) {
        console.log(err);
      }
    };

    fetchBlogDetail();
    fetchPageData("blogs", setFetchblogs, setLoader, true, false);
  }, [slug]);

  function truncateTo30Words(text) {
    const words = text?.trim()?.split(/\s+/);
    if (words?.length <= 30) return text;
    return words?.slice(0, 30)?.join(" ") + "...";
  }
  console.log("Blog data in single blog", blogData);
  console.log("blogs>>>", fetchBlogs);

  // /blogs?filters[slug][$eq]=the-impact-of-technology-on-the-workplaces

  return (
    <MainLayout loader={loader}>
      <div style={{ backgroundColor: "#090D24", color: "#fff" }}>
        <div className="container-fluid p-0 m-0">
          <Toaster position="top-center" />
          <div className="container px-0 pb-5 pt-4 contwidth">
            <div className="d-flex flex-column gap-3">
              <div
                className={`d-flex align-items-center justify-content-center ${
                  isMobile ? "px-4" : "rounded-5"
                } `}
                style={{
                  height: isMobile
                    ? "auto"
                    : _1500
                    ? "370px"
                    : _1600
                    ? "350px"
                    : _1800
                    ? "350px"
                    : "477px",
                }}
              >
                <img
                  src={`${baseUrl}${blogData?.thumbnail?.url}`}
                  alt=""
                  style={{
                    objectFit: "cover",
                    width: "100%",
                    // height: isMobile ? "auto" : "477px",
                    height: isMobile
                      ? "auto"
                      : _1500
                      ? "370px"
                      : _1600
                      ? "350px"
                      : _1800
                      ? "350px"
                      : "477px",
                    borderRadius: "20px",
                  }}
                  className={``}
                />
              </div>
              {/* <div
              style={{
                display: "flex",
                gap: "10px",
                // padding: "0 24px",
              }}
            > */}
              <Breadcrumb
                separator={""}
                className=" fw500 px-4 pt-4"
                style={{
                  fontSize: _576
                    ? "12px"
                    : _768
                    ? "12px"
                    : _992
                    ? "14px"
                    : _1200
                    ? "14px"
                    : _1400
                    ? "16px"
                    : _1600
                    ? "18px"
                    : _1700
                    ? "18px"
                    : _1800
                    ? "20px"
                    : "20px",
                }}
              >
                {/* <Breadcrumb.Item className="text-white">{`/${blogData?.heading}`}</Breadcrumb.Item> */}
                <Breadcrumb.Item className="text-white">
                  Ask Fides
                </Breadcrumb.Item>
                <span className="mx-2 text-white"> / </span>
                <Breadcrumb.Item
                  onClick={() => Navigate("/blogs")}
                  className="text-white pe-2 cursor-pointer"
                >
                  Blogs
                </Breadcrumb.Item>
              </Breadcrumb>
              {/* {blogData?.tags?.map((tag, tagIndex) => (
                <div
                  key={tagIndex}
                  className="d-flex mt-3 text-white rounded-3 mt-1 "
                  style={{ padding: "5px 20px", backgroundColor: " #4B6BFB" }}
                >
                  {tag}
                </div>
              ))} */}
              {/* </div> */}
              <h1
                className={`text-start pt-3 px-4  fw800`}
                style={{
                  lineHeight: _768 ? "2.5rem" : _1400 ? "3rem" : "3.8rem",
                  fontSize: _576
                    ? "20px"
                    : _768
                    ? "25px"
                    : _992
                    ? "30px"
                    : _1200
                    ? "35px"
                    : _1400
                    ? "40px"
                    : _1600
                    ? "50px"
                    : _1700
                    ? "55px"
                    : _1800
                    ? "60px"
                    : "60px",
                }}
              >
                {blogData?.heading}
              </h1>
              {/* <p
                className={`text-start pt-2 px-4 text-white   fw500`}
                style={{
                  lineHeight: _1400 ? "1.5rem" : "2rem",
                  fontSize: _576
                    ? "15px"
                    : _768
                    ? "15px"
                    : _992
                    ? "15px"
                    : _1200
                    ? "20px"
                    : _1400
                    ? "20px"
                    : _1600
                    ? "25px"
                    : _1700
                    ? "25px"
                    : _1800
                    ? "30px"
                    : "30px",
                }}
                dangerouslySetInnerHTML={{
                  __html: blogData?.excerpt,
                }}
              ></p> */}
            </div>

            <div className="row  px-5 pt-5">
              {blogData?.quotations?.map((quote) => {
                return (
                  <div className="col-12 col-md-6 col-lg-4">
                    <QuotationCard quote={quote} />
                  </div>
                );
              })}
            </div>

            <div className="row px-0 px-md-4 pt-5">
              {/* col-md-8 */}
              <div
                className={`col-12 col-md-9 ${isMobile ? "px-5 mb-5" : "pe-5"}`}
              >
                <MarkdownComponent
                  markdown={blogData?.description}
                  imgwidth={isMobile ? "" : "756px"}
                  imgheight={isMobile ? "" : "427px"}
                  markdowncss={isMobile ? "" : "text-center"}
                />
              </div>
              {/* col-md-4 */}
              <div
                className="col-12 col-md-3 d-flex flex-column align-items-center gap-5"
                style={{
                  maxHeight: isMobile ? "max-content" : "auto",
                  overflowX: "hidden",
                  overflowY: isMobile ? "" : "scroll",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {/* make subsrciption */}
                <div
                  className="w-100  rounded-4 text-center subscription-sticky"
                  style={{
                    color: "#fff",
                    padding: "3rem 1rem",
                    boxShadow: "0 4px 24px rgba(0, 29, 145, 0.4)",
                    background: "#090D24",
                  }}
                >
                  <div className="mb-3 fw-bold" style={{ fontSize: "1.1rem" }}>
                    Want more content like this? <br />
                    Subscribe for our new updates and blogs.
                  </div>
                  <form
                    onSubmit={(e) => onSubmit(e, setBtnLaoder)}
                    className="d-flex flex-column gap-2 align-items-center w-100"
                  >
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Enter your email"
                      style={{ width: "100%", maxWidth: 260 }}
                      required
                    />
                    <button
                      type="submit"
                      className="btn  fw-bold"
                      style={{
                        color: "#fff",
                        border: "none",
                        width: "100%",
                        maxWidth: 260,
                        backgroundColor: "rgb(31, 70, 190)",
                      }}
                    >
                      Subscribe
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <div
              className="row py-5 flex-md-nowrap gap-2"
              style={{
                overflowX: isMobile ? "" : "auto",
                overflowY: "hidden",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {/* <div className="col-12"> */}
              {/* {fetchBlogs?.blogs?.slice(0, 3)?.map((item, index) => (
                <BlogCard key={index} item={item} />
              ))} */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default SingleBlog;
